export { Modal as default } from '@portal-internet/components';
